"use client";

import type {
  QuickPayOutput,
  QuickPayReceiptContext,
} from "@tillix/api-contract/client-schemas";
import { FEE_BY_METHOD } from "@/features/pay/state/payment-fees";
import {
  type QuickPayCheckFormValues,
  quickPayCheckFormSchema,
} from "../schemas/quick-pay-form";
import { useQuickPayForm } from "./use-quick-pay-form";

interface UseQuickPayCheckFormParams {
  tenantId: string;
  externalId: string;
  nameOnAccount?: string;
  zipCode?: string;
  amount: number;
  onSuccess: (result: QuickPayOutput, context: QuickPayReceiptContext) => void;
}

// FIXME: these changes invariably break a lot of things
export function useQuickPayCheckForm(params: UseQuickPayCheckFormParams) {
  return useQuickPayForm<QuickPayCheckFormValues>({
    ...params,
    schema: quickPayCheckFormSchema,
    defaultValues: {
      firstName: "",
      lastName: "",
      routingNumber: "",
      checkAccountNumber: "",
      checkAccountType: "Personal",
      fundingAccountType: "Checking",
      email: "",
      address1: "",
    },
    buildPayload: (values, clientRequestId) => ({
      clientRequestId,
      tenantId: params.tenantId,
      externalId: params.externalId,
      ...(params.nameOnAccount ? { nameOnAccount: params.nameOnAccount } : {}),
      ...(params.zipCode ? { zipCode: params.zipCode } : {}),
      email: values.email,
      amount: params.amount,
      fee: FEE_BY_METHOD.BANK_ACCOUNT,
      requestType: "check",
      checkDetail: {
        checkAccountNumber: values.checkAccountNumber,
        routingNumber: values.routingNumber,
        firstName: values.firstName,
        lastName: values.lastName,
        checkAccountType: values.checkAccountType,
        fundingAccountType: values.fundingAccountType,
      },
      address: {
        address1: values.address1,
      },
    }),
    buildReceiptContext: (values) => ({
      payerName: `${values.firstName} ${values.lastName}`,
      lastFour: values.checkAccountNumber.slice(-4),
      paymentType: "check",
      email: values.email,
    }),
  });
}
